import { useState, useEffect } from "react";
import { SurveyServices } from "../services/SurveyServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import CloseIcon from "../assets/crossIcon.svg";
import RemoveIcon from "../assets/deleteIcon.svg";
const AddSurveyQuestions = ({ getQuestionList, setOpen, sequence }) => {
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(null);
  const [optionValue, setoptionValue] = useState("");
  const [saving, setSaving] = useState(false);
  const handleAddOption = () => {
    if (options) {
      options.length < 6
        ? setOptions([...options, optionValue])
        : window.alert("You can not add more than 6 options");
    } else {
      setOptions([optionValue]);
    }
    setoptionValue("");
  };
  const handleRemove = (index) => {
    const filteredData = options.filter((_, idx) => idx !== index);
    setOptions(filteredData);
  };
  const handleSaveQuestionDetails = async () => {
    setSaving(true);
    const data = [
      {
        question: question,
        options: options,
        sequence: sequence,
        status: "active",
      },
    ];
    console.log("added question data:", data);
    if (!question) {
      window.alert("Question is required");
    } else if (!options || options.length === 0) {
      window.alert("Atleast one option is required");
    } else {
      try {
        const response = await SurveyServices.addSurveyQuestions(data);
        window.alert(response?.data?.message);
        await getQuestionList();
        setOpen(false);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }

    setSaving(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 bg-[#017C5780] w-screen h-screen flex justify-center items-center z-[1200]">
      <div className="relative max-h-[70%] w-[50%] bg-white rounded-[16px] p-5 overflow-y-scroll">
        <div
          className="absolute top-4 right-4 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="text-xl font-semibold text-[#191919]">Add Question</div>

        <div className="mt-5">
          <label htmlFor="question" className="font-semibold">
            Question
          </label>
          <br />
          <textarea
            name="question"
            id="question"
            value={question}
            style={{ border: "1px solid #c4c4c4" }}
            className="mt-2 rounded-[8px] w-[90%] h-[100px] p-4"
            onChange={(e) => setQuestion(e.target.value)}
          />

          <div className="mt-2 px-3">
            {options &&
              options?.map((option, idx) => {
                return (
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-[#777] mt-1">
                      {idx + 1 + "." + " " + option}
                    </div>
                    <img
                      src={RemoveIcon}
                      alt="remove-icon"
                      className="w-[14px] h-[14px] cursor-pointer"
                      onClick={() => handleRemove(idx)}
                    />
                  </div>
                );
              })}
          </div>
          <div
            style={{ border: "1px solid #e4e4e4" }}
            className="p-3 rounded-[8px] mt-3"
          >
            <label htmlFor="option" className="font-semibold">
              Option Value
            </label>
            <br />
            <div className="flex gap-2 items-center">
              <textarea
                name="option"
                id="option"
                value={optionValue}
                style={{ border: "1px solid #c4c4c4" }}
                className="mt-2 rounded-[8px] w-[80%] h-[50px] p-4"
                onChange={(e) => setoptionValue(e.target.value)}
              />

              <div
                onClick={handleAddOption}
                style={{ border: "1px solid #017C57" }}
                className="w-fit text-sm font-semibold  text-[#017C57] px-8 py-3 rounded-full mt-2 cursor-pointer"
              >
                Add Option
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-4">
          {saving ? (
            <CircularProgress />
          ) : (
            <div
              className="text-sm font-semibold text-white bg-[#017C57] py-3 px-8 uppercase rounded-full cursor-pointer"
              onClick={handleSaveQuestionDetails}
            >
              Save Question Details
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddSurveyQuestions;
